export async function withPagination(fn, { pageSize, pageNumber }) {
  const state = {
    pageNumber,
    pageSize,
    totalPages: 1,
    totalCount: 0,
    value: {},
    valueArray: [],
    extraData: [],

    async nextPage() {
      if (state.pageNumber > state.totalPages) {
        return Promise.resolve({ state });
      }
      return fn({ ...state, pageNumber: state.pageNumber + 1 }).then(
        ({ data: { pagination, payload, balance, outstandingCount } }) => {
          state.pageNumber += 1;
          state.value[state.pageNumber] = payload;
          state.valueArray = getValueArray(state.value);

          return { state, payload };
        },
      );
    },
    prevPage() {
      if (state.pageNumber === 1) {
        return Promise.resolve({ state });
      }
      return fn({ ...state, pageNumber: state.pageNumber - 1 }).then((cards) => {
        state.pageNumber -= 1;
        return { state, payload: cards };
      });
    },
  };

  return fn(state).then(
    ({
      data: {
        pagination,
        payload,
        balance,
        outstandingCount,
        totalProgress,
        defaultSortBy,
        defaultSortOrder,
      },
    }) => {
      state.value[1] = payload;
      state.valueArray = getValueArray(state.value);
      state.totalCount = pagination.totalCount;
      state.totalPages = pagination.totalPage;

      state.extraData = {
        balance: balance,
        outstandingCount: outstandingCount,
        totalProgress: totalProgress,
        defaultSortBy: defaultSortBy,
        defaultSortOrder: defaultSortOrder,
      };

      return state;
    },
  );
}

function getValueArray(value) {
  return Object.values(value).flat(Infinity);
}
